import { RadioGroupForm } from 'components/ui/controlled-form/RadioGroupForm/RadioGroupForm.js';
import type { GenericFormField } from 'components/ui/form/GenericForm/GenericForm.types.js';
import type { Control } from 'react-hook-form';

export const IssueFormYesNo = (props: { control: Control; field: GenericFormField }) => {
  return (
    <RadioGroupForm
      control={props.control}
      field={{
        ...props.field,
        options: [
          { label: 'Yes', value: 'yes' },
          { label: 'No', value: 'no' },
        ],
      }}
      transform={{
        onChange: event => event.target.value === 'yes',
        value: value => (value ? 'yes' : 'no'),
      }}
    />
  );
};
